export default __webpack_public_path__ + "static/media/agonizingjolts.205d9977.png";